


import { Box, Image, Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react";
import SectionTitle from "@components/Headings/SectionTitle";
import TopKolam from "@components/Headings/TopKolam";
import StructuredTextParser from "@components/Utility/ArticleParser/StructuredTextParser13";
import { render } from "datocms-structured-text-to-html-string";
import { useEffect, useState } from 'react';
import { useMediaQuery } from "react-responsive";
import config from '@config';

const FacilitiesAndInclusionsV2 = ({ sectionContent, region, lang }) => {
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const getTabContent = (index) => {
        const images = sectionContent[index]?.tabContent[0]?.content[1]?.images || [];
        const text = sectionContent[index]?.tabContent[0]?.content[0]?.body || '';
        return { content: images.map(image => image.url), text };
    }

    const [tabs, setTabs] = useState([
        getTabContent(3),
        getTabContent(5),
        getTabContent(7),
    ]);
    const allImages = tabs.reduce((acc, tab) => acc.concat(tab.content), []);
    const allText = tabs.reduce((acc, tab) => acc.concat(tab.text), []);
    const switchContent = (tabIndex, boxIndex) => {
        const newTabs = [...tabs];
        [newTabs[tabIndex].content[0], newTabs[tabIndex].content[boxIndex]] = [newTabs[tabIndex].content[boxIndex], newTabs[tabIndex].content[0]];
        setTabs(newTabs);
    };
    const [activeTab, setActiveTab] = useState(0);

    const renderTab = (index, activeIndex) => (
        <Tab
            border={"1px"}
            borderColor={"#AAAAAA"}
            px={"30px"}
            height={"58px"}
            fontFamily={"FedraSansStd-book"}
            fontWeight={"semibold"}
            borderRadius={"10px"}
            fontSize={'18px'}
            _selected={{ border: "1px", borderColor: "#FFAE27", color: 'black', bg: '#FFAE27' }}
        >
            {sectionContent[index]?.titleText}
        </Tab>
    );
    useEffect(() => {
        const handleScroll = () => {
            const boxWidth = 282;
            const scrollLeft = document.querySelector('.scroll-container').scrollLeft;
            const currentBox = Math.floor(scrollLeft / boxWidth) + 1;

            if (currentBox <= 3) {
                setActiveTab(0);
            } else if (currentBox <= 6 && currentBox >= 4) {
                setActiveTab(1);
            } else {
                setActiveTab(2);
            }
        };
        if (window.innerWidth <= 768) {
            document.querySelector('.scroll-container')?.addEventListener('scroll', handleScroll);
        }

        return () => {
            if (window.innerWidth <= 768) {
                document.querySelector('.scroll-container')?.removeEventListener('scroll', handleScroll);
            }
        };
    }, []);

    const handleChange = (index) => {
        setActiveTab(index);
        const scrollContainer = document.querySelector('.scroll-container');
        if (scrollContainer) {
            const boxWidth = 313;
            const scrollLeft = index * boxWidth * 3;
            scrollContainer.scrollLeft = scrollLeft;
        }
    };

    const Dots = ({ activeIndex }) => {
        return (
            <Box display="flex" justifyContent="center" 
            >
                {[0, 1, 2].map((_, index) => (
                    <Box
                        marginTop={"-10px"}
                        key={index}
                        w="10px"
                        h="10px"
                        borderRadius="50%"
                        bg={index === activeIndex ? "black" : "gray.300"}
                        opacity={index === activeIndex ? 1 : 0.5}
                        mx={1}
                    />
                ))}
            </Box>
        );
    };

    return (
            <Box marginBottom={{ sm: "", base: "", md: "50px" }}
                bgImage={{base:'', md:`url(${config.imgPath}/d/46272/1733835026-left_facilities.png)`}}
                bgRepeat={'no-repeat'}
                bgPosition={'left bottom 17%'}
            >
             <Box 
                bgImage={{base:'', md:`url(${config.imgPath}/d/46272/1733835026-right_facilities.png)`}}
                bgRepeat={'no-repeat'}
                bgPosition={'right top'}
            >
                <Box
                    fontWeight={'600'}
                    color="#262626"
                    fontSize={{ base: '30px', md: '32px', lg:'32px' }}
                    lineHeight={{ base: '37.8px', md: '47px' }}
                    mx={{ base: '17px', md: 'auto' }}
                    margin={'auto'}
                    textAlign={'center'}
                    font-family={"Fedra Serif A Std"}
                >
                    {sectionContent[0].titleText}
                </Box>
                <Box marginTop={"-30px"}>
                    <TopKolam
                        sectionContent={sectionContent[1]}
                    />
                </Box>
            
            {
                isMobile ? <Box marginTop={"56px"} marginBottom={"40px"}>

                    <Tabs

                        index={activeTab}
                        onChange={(index) => handleChange(index)}
                        variant='unstyled' >
                        <TabList overflow={"auto"}
                            display={"flex"} gap={"16px"} mx={"16px"}
                            css={{
                                scrollbarWidth: 'none',
                                '-ms-overflow-style': 'none',
                                '&::-webkit-scrollbar': {
                                    display: 'none'
                                }
                            }}
                        >
                            {renderTab(2)}
                            {renderTab(4)}
                            {renderTab(6)}
                        </TabList>


                        <Box margin={"36px 0px"} overflow={"auto"}
                            display={"flex"}
                            className="scroll-container"
                            css={{
                                scrollbarWidth: 'none',
                                '-ms-overflow-style': 'none',
                                '&::-webkit-scrollbar': {
                                    display: 'none'
                                }
                            }}>
                            {
                                allImages.map((img, index) => {
                                    return (
                                        <Box

                                            className="scroll-container"
                                            position={"relative"} id={index} mx={"16px"} minHeight={"339px"} minWidth={"282px"} >
                                            <Image objectFit="cover" width="282px" height="339px" src={img} />
                                            {(index === 0 || index === 3 || index === 6) && (
                                                <>
                                                    <Box
                                                        position="absolute"
                                                        bottom="0"
                                                        width="100%"
                                                        height="70%"
                                                        background="linear-gradient(0deg, rgba(0,0,0,20) 0%, rgba(0,0,0,20) 60%, rgba(0,0,0,0) 100%)"
                                                        opacity="0.75"
                                                        // background="linear-gradient(0deg, rgba(0,0,0,2) 0%, rgba(0,0,0,2) 60%, rgba(0,0,0,0) 100%)"
                                                        filter={""}
                                                        box-shadow="0px 0px 40px 40px #000000"
                                                    />
                                                    <Box position="absolute" color="white" bottom={"20px"} left={"10px"} right={"10px"}>
                                                        <StructuredTextParser
                                                            lineHeight="24px"
                                                            fontFamily="FedraSansStd-book" fontSize="16px" textAlign="center"
                                                            str={render(index === 0 ? allText[0] : index === 3 ? allText[1] : allText[2])}
                                                        />
                                                    </Box>
                                                </>
                                            )}
                                        </Box>
                                    )
                                })
                            }
                        </Box>
                        <Dots activeIndex={activeTab} />

                    </Tabs>
                </Box> :
                    <Box marginTop={"56px"}>
                        <Tabs variant='unstyled'>
                            <TabList display={"flex"} gap={"16px"} justifyContent={"center"} alignItems={"center"}>
                                {renderTab(2)}
                                {renderTab(4)}
                                {renderTab(6)}
                            </TabList>
                            <TabPanels minHeight={"637px"} marginTop={"50px"} maxWidth={"681px"} mx={"auto"}>
                                {tabs.map((tab, tabIndex) => {
                                    // console.log("the content is", tab)
                                    return (
                                        <TabPanel key={tabIndex}>
                                            <Box cursor={"pointer"} display={"flex"} flexDirection={{ base: "", sm: "", md: "column" }} gap={"20px"}>
                                                <Box position={"relative"}>
                                                    {tab?.content?.map((content, boxIndex) => {

                                                        if (boxIndex === 0) {
                                                            return (
                                                                <Box
                                                                    key={boxIndex}
                                                                    position={"relative"}
                                                                    height="415px"
                                                                    width={{ base: "", sm: "", md: "" }}
                                                                    onClick={() => switchContent(tabIndex, boxIndex)}
                                                                >
                                                                    <Image objectFit="cover" width="100%" height="100%" src={content} />
                                                                    <Box
                                                                        position="absolute"
                                                                        bottom="0"
                                                                        width="100%"
                                                                        height="35%"
                                                                        background="linear-gradient(0deg, rgba(0,0,0,20) 0%, rgba(0,0,0,20) 60%, rgba(0,0,0,0) 100%)"
                                                                        opacity="0.75"
                                                                        box-shadow="0px 0px 40px 40px #000000"
                                                                    />

                                                                </Box>
                                                            );
                                                        } else {
                                                            return null;
                                                        }

                                                    })}
                                                    <Box color={"white"} position={"absolute"} bottom={"35px"} left={"30px"} right={"30px"} lineHeight={'24px'}>
                                                        <StructuredTextParser fontFamily="FedraSansStd-book"  fontSize="16px" textAlign="center" str={render(tab?.text)} />
                                                    </Box>
                                                </Box>
                                                <Box display="flex" gap={"16px"}>
                                                    {tab?.content?.map((content, boxIndex) => {
                                                        if (boxIndex !== 0) {
                                                            return (
                                                                <Box
                                                                    key={boxIndex}
                                                                    height="201px"
                                                                    width={{ base: "", sm: "", md: "330px" }}
                                                                    onClick={() => switchContent(tabIndex, boxIndex)}
                                                                >
                                                                    <Image objectFit="cover" width="100%" height="100%" src={content} />
                                                                </Box>
                                                            );
                                                        } else {
                                                            return null;
                                                        }
                                                    })}
                                                </Box>
                                            </Box>
                                        </TabPanel>
                                    )
                                }
                                )}
                            </TabPanels>
                        </Tabs>
                    </Box>
            }
            </Box>
        </Box >
    );
};

export default FacilitiesAndInclusionsV2;